const localeMap = {
  'new-order': 'Новый заказ',
  'my-orders': 'Мои заказы',
  'my-dealers': 'Мои поставщики',
  'invoices': 'Выплаты',
  'products': 'Товары',
  'dropspot': 'DropSpot',
}

export default function (pathname) {
  let parts = pathname.split('/');
  parts.shift();

  parts = parts.map((part, i) => {
    return {
      key: part,
      title: localeMap[part] || part,
      link: `/${parts.slice(0, i + 1).join('/')}`,
      isActive: false
    };
  });

  parts[parts.length - 1].isActive = true;

  return parts;
}
